const CANVAS_SIZE = 20;
const IMAGE_SIZE = 16;

const NumbersMap = new Map<number, Node>();

const generateNumberImage = (number: number) => {
  const canvas = document.createElement("canvas");
  canvas.setAttribute("width", CANVAS_SIZE.toString());
  canvas.setAttribute("height", CANVAS_SIZE.toString());
  const context = canvas.getContext("2d")!;

  // Set canvas background color
  context.fillStyle = "transparent";
  context.fillRect(0, 0, canvas.width, canvas.height);

  // Set text properties
  context.fillStyle = "#fff";
  context.font = "12px Helvetica";
  context.textAlign = "center";
  context.textBaseline = "middle";

  // Draw the number
  context.fillText(number.toString(), canvas.width / 2, canvas.height / 2);

  // Convert to base64
  const base64Image = canvas.toDataURL("image/png");

  // You can also display the image if needed
  const imgElement = document.createElement("img");
  imgElement.src = base64Image;
  imgElement.width = IMAGE_SIZE;
  imgElement.height = IMAGE_SIZE;

  return imgElement;
};

export function createImageWithNumber(number: number) {
  if (NumbersMap.has(number)) {
    return NumbersMap.get(number);
  }

  const imgElement = generateNumberImage(number);

  NumbersMap.set(number, imgElement);

  return imgElement;
}
